import React, { useState } from 'react'
import { Form, Button, Container, Row, Col, Nav } from 'react-bootstrap'
import "../assets/styles/index.css"
import { Link, useNavigate } from 'react-router-dom'
import { useForgotPasswordMutation, useSendOtpMutation } from '../slices/usersApiSlice'
import { parseUserInfo } from '../utils/parseUtil'
import { toast } from 'react-toastify'

const ForgotPasswordScreen = () => {
    const [empCode, setEmpCode] = useState('')

    const navigate = useNavigate()

    const [sendOtp, { isLoading: loadingSendOtp }] = useSendOtpMutation()
    const [forgotPassword, { isLoading }] = useForgotPasswordMutation()

    const handleSubmit = async (e) => {
        e.preventDefault()
        const formData = new FormData()
        formData.append('ReqUserID', empCode)
        formData.append('ReqPassWord', '')
        formData.append('description', 'GetStaffDetails')
        formData.append('title', 'GetStaffInfoJason')
        formData.append('ReqType', 'forgotpass')

        try {
            const res = await forgotPassword(formData)
            const parsedUserInfo = parseUserInfo(res)

            if (parsedUserInfo) {
                const infoField1 = parsedUserInfo[0]?.InfoField1
                const userId = parsedUserInfo[0]?.InfoField2
                const companyCode = parsedUserInfo[13]?.InfoField
                const userName = parsedUserInfo[2]?.InfoField
                const SMSTYPE = process.env.REACT_APP_SMS_TYPE || ""

                if (infoField1 === "0") {
                    // Store data in localStorage
                    localStorage.setItem('userId', userId)
                    localStorage.setItem('companyCode', companyCode)
                    localStorage.setItem('userName', userName)

                    const otpFormData = new FormData()
                    otpFormData.append('title', 'SentVerificationCodeStaff')
                    otpFormData.append('description', 'SentVerificationCodeStaff')
                    otpFormData.append('ReqUserID', userId)
                    otpFormData.append('ReqCompanyCode', companyCode)
                    otpFormData.append('ReqSMSType', SMSTYPE)

                    await sendOtp(otpFormData)
                    navigate('/otp', { state: { userId, companyCode, userName } })
                } else {
                    toast.error(parsedUserInfo[0]?.InfoField || 'Login & Active Staff Record Found')
                }
            } else {
                toast.error('Failed to parse user info')
            }
        } catch (err) {
            toast.error(err?.data?.message || err.error)
        }
    }

    return (
        <Container className="form-container mt-5">
            <Row className="justify-content-md-center">
                <Col md={6}>
                    <h3 className="mt-4 text-center form-title">Forgot Password</h3>
                    <Form className="border p-4 rounded form-background" onSubmit={handleSubmit}>
                        <Form.Group controlId="empCode" className="mb-3">
                            <Form.Label>Employee Code</Form.Label>
                            <Form.Control
                                type="empCode"
                                placeholder="Enter Employee Code"
                                value={empCode}
                                onChange={(e) => setEmpCode(e.target.value)}
                                required
                                className="form-control-hover"
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="mt-3 btn-custom">
                            Forgot Password
                        </Button>
                        <p className='pt-3 text-center'>Back to{' '}
                            <Nav.Link as={Link} to="/login" className='d-inline p-0'>
                                <span className='text-primary text-decoration-underline'>Login</span>
                            </Nav.Link>
                        </p>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default ForgotPasswordScreen
